var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['lserv-spacer', _vm.block ? 'block' : null],style:(_vm.cssProps)})}
var staticRenderFns = []

export { render, staticRenderFns }